module.exports = __webpack_public_path__ + "6ced84f027ff35069e15056945dd7546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imagecache_defaults.png
// module id = 85
// module chunks = 1